const STORE_PROVIDER = (state, provider) => {
  state.provider = provider;
};

const STORE_PROVIDERS = (state, providers) => {
  state.providers = providers;
};

const STORE_PROVIDER_RECEITA = (state, providerReceita) => {
  state.providerReceita = providerReceita;
};

const STORE_ISS = (state, iss) => {
  state.iss = iss;
};

const STORE_RECIPE_CODE = (state, recipeCode) => {
  state.recipeCode = recipeCode;
};

const STORE_FORMA_PAGAMENTO = (state, formaPagamento) => {
  state.formaPagamento = formaPagamento;
}
export default {
  STORE_PROVIDER,
  STORE_PROVIDERS,
  STORE_PROVIDER_RECEITA,
  STORE_ISS,
  STORE_RECIPE_CODE,
  STORE_FORMA_PAGAMENTO
};
